export default __webpack_public_path__ + "static/mike-8a81ce7c095d441a33e4a3a31896c75b.png";